import { Box, Flex } from '@chakra-ui/react';

import SkeletonComponent from 'UiKit/skeleton';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

const SkeletonHostSchedule = () => (
  <Box className={styles['host-schedule-skeleton__container']}>
    <Iteration
      items={[1, 2, 3, 4, 5, 6, 7]}
      render={(num) => (
        <Box className={styles['skeleton__item']} key={num}>
          <Box className={styles['head__section']}>
            <SkeletonComponent height="14px" mb="4px" width="200px" />
          </Box>

          <Box className={styles['content__section']}>
            <Iteration
              items={[1, 2, 3]}
              render={(num) => (
                <Box className={styles['card']} key={num}>
                  <Flex className={styles['head-card__section']}>
                    <SkeletonComponent height="14px" width="80%" />
                    <SkeletonComponent height="14px" width="14px" />
                  </Flex>
                  <SkeletonComponent height="17px" width="136px" mb="6px" />
                  <SkeletonComponent height="12px" width="140px" mb="4px" />
                </Box>
              )}
            />
          </Box>
        </Box>
      )}
    />
  </Box>
);

export default SkeletonHostSchedule;
